/**
 * WordPress URL Helper Functions
 * Provides dynamic URL building for different environments
 */

/**
 * Build API URL for WordPress REST API endpoints
 * @param {string} endpoint - The API endpoint (e.g., 'wp/v2/posts')
 * @returns {string} Complete API URL
 */
export const buildApiUrl = (endpoint) => {
  if (window.wpData?.restUrl) {
    return `${window.wpData.restUrl}${endpoint}`;
  }
  return `${window.location.origin}/wp-json/${endpoint}`;
};

/**
 * Get the WordPress site base path
 * @returns {string} Base path for routing
 */
export const getSiteBasePath = () => {
  if (window.wpData?.siteUrl) {
    return new URL(window.wpData.siteUrl).pathname;
  }
  return '/';
};

/**
 * Build internal site URL
 * @param {string} path - The internal path (e.g., '/practice-areas')
 * @returns {string} Complete internal URL
 */
export const buildSiteUrl = (path) => {
  const basePath = getSiteBasePath();
  return `${basePath}${path}`.replace(/\/+/g, '/'); // Remove double slashes
};

/**
 * Get theme asset URL
 * @param {string} assetPath - The asset path (e.g., '/build/image.jpg')
 * @returns {string} Complete asset URL
 */
export const getThemeAssetUrl = (assetPath) => {
  if (window.wpData?.themeUrl) {
    return `${window.wpData.themeUrl}${assetPath}`;
  }
  return assetPath;
};